<template lang='pug'>
.base
  CursorCustom(:theme="theme")
  BaseView(
    :theme="theme"
    :appear="appear"
    :scrollbar="scrollbar"
    )
    .location
      .location__map
        .map__overlay
        MapBox
</template>

<script>
import BaseView from "../../views/BaseView/index";
import MapBox from "../../components/elements/LocationMap/index";
import CursorCustom from "../../components/elements/Cursor/index";
export default {
  name: "Documents",
  data() {
    return {
      type: "half",
      theme: "dark",
      appear: "normal",
      scrollbar: true,
      contactsKey: 0,
    };
  },
  methods: {
    clearCursor() {
      document.querySelector(".circle-cursor--outer").remove();
      document.querySelector(".circle-cursor--inner").remove();
    },
    showPage() {
      this.$el.classList.add("active");
    }
  },
  mounted() {
    this.showPage();
  },
  beforeDestroy() {
    this.clearCursor();
  },
  components: {
    BaseView,
    CursorCustom,
    MapBox,
  }
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/medias"
@import "src/sass/general/variables"

.base
  background: $dark
.location
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  &__map
    position: absolute
    top: inherit
    left: inherit
    width: 100%
    height: 100%
    transition-duration: .7s
    .map__overlay
      content: ''
      width: 100%
      height: 100%
      position: absolute
      z-index: 5
      top: 0
      visibility: hidden
      transition-duration: .5s
      opacity: 0
      left: 0
      background: $brown
      &--active
        visibility: visible
        opacity: 1
  
</style>
